<!-- 评价表单 -->
<template>
    <div class="layui-colla-two">
        <div class="layui-colla-item layui-colla-two-item" v-show="editRow.EVALUATE_TIME_MANAGER">
            <h2 class="layui-colla-title">项目经理对服务商评价信息</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-one">
                    <div class="layui-form-item">
                        <label class="layui-form-label">工程师：</label>
                        <label class="layui-form-label right">{{editRow.ENGINEER_NAME}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">服务商：</label>
                        <label class="layui-form-label right">{{editRow.SERVICE_NAME}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">是否准时：</label>
                        <label class="layui-form-label right" v-if="!editable">{{editRow.EVALUATE_ZS_MANAGER_DESC}}</label>
                        <div class="layui-input-inline" style="width: 60%"  v-if="editable">
                            <layui-radio v-model="editRow.EVALUATE_ZS_MANAGER" name="EVALUATE_ZS_MANAGER">
                                <input type="radio" value="1" title="准时" />
                                <input type="radio" value="2" title="不准时" />
                            </layui-radio>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">技术评价：</label>
                        <label class="layui-form-label right"  v-if="!editable">{{editRow.EVALUATE_JS_MANAGER_DESC}}</label>
                        <div class="layui-input-inline" style="width: 60%"  v-if="editable">
                            <layui-radio v-model="editRow.EVALUATE_JS_MANAGER" name="EVALUATE_JS_MANAGER">
                                <input type="radio" value="1" title="好" />
                                <input type="radio" value="2" title="一般" />
                                <input type="radio" value="3" title="差" />
                            </layui-radio>
                        </div>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">备注：</label>
                        <label class="layui-form-label right textarea" v-if="!editable">{{editRow.EVALUATE_REMARKS_MANAGER}}</label>
                        <div class="layui-input-inline" style="width:60%" v-if="editable">
                            <textarea v-model="editRow.EVALUATE_REMARKS_MANAGER" name="EVALUATE_REMARKS_MANAGER" class="layui-textarea"></textarea>
                        </div>
                    </div>
<!--                    <div class="layui-form-item">
                        <label class="layui-form-label">评价人：</label>
                        <label class="layui-form-label right" v-if="!editable">{{editRow.MANAGER_NAME}}</label>
                        <div class="layui-input-inline" style="width: 60%" v-if="editable">
                            <input
                                type="text"
                                v-model="editRow.MANAGER_NAME"
                                autocomplete="off"
                                class="layui-input"
                                name="MANAGER_NAME"
                                placeholder="请输入评价人"/>
                        </div>
                    </div>-->
                    <div class="layui-form-item">
                        <label class="layui-form-label">评价时间：</label>
                        <label class="layui-form-label right" v-if="!editable">{{editRow.EVALUATE_TIME_MANAGER}}</label>
                        <div class="layui-input-inline" style="width: 60%" v-if="editable">
                            <layui-datetime :showNewDate="true" name="EVALUATE_TIME_MANAGER" v-model="editRow.EVALUATE_TIME_MANAGER" placeholder="评价时间"></layui-datetime>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="layui-colla-item layui-colla-two-item" v-show="editRow.EVALUATE_TIME">
            <h2 class="layui-colla-title">服务商对项目经理评价信息</h2>
            <div class="layui-colla-content layui-show">
                <div class="layui-form-item-one">
                    <div class="layui-form-item">
                        <label class="layui-form-label">项目经理：</label>
                        <label class="layui-form-label right">{{editRow.MANAGER_NAME}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">回复是否准时：</label>
                        <label class="layui-form-label right">{{editRow.EVALUATE_ZS_DESC}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">回复是否准确：</label>
                        <label class="layui-form-label right">{{editRow.EVALUATE_ZQ_DESC}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">服务态度：</label>
                        <label class="layui-form-label right">{{editRow.EVALUATE_TD_DESC}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">备注：</label>
                        <label class="layui-form-label right textarea">{{editRow.EVALUATE_REMARKS}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">评价人：</label>
                        <label class="layui-form-label right">{{editRow.SERVICE_NAME}}</label>
                    </div>
                    <div class="layui-form-item">
                        <label class="layui-form-label">评价时间：</label>
                        <label class="layui-form-label right">{{editRow.EVALUATE_TIME}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            editRow: {
                default: () => ({}),
                type: Object
            },
            enabled: {
                type: Boolean,
                default: false,
            }
        },
        data () {
            return {
                editable:false,
            }
        },
        mounted () {
            this.editable = this.enabled;
        },
        watch:{
            enabled:{//深度监听，可监听到对象、数组的变化
                handler(val, oldVal){
                    this.editable = val;
                },
                deep:true //true 深度监听
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/workOrder/detailForm/appraiseForm.vue